import { render } from "./ChallengesView.vue?vue&type=template&id=282193a1&scoped=true"
import script from "./ChallengesView.vue?vue&type=script&lang=js"
export * from "./ChallengesView.vue?vue&type=script&lang=js"

import "./ChallengesView.vue?vue&type=style&index=0&id=282193a1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282193a1"]])

export default __exports__